export default "assets/images/logo-top-c1bf4a27.svg";